<script setup>
import {useI18n} from 'vue-i18n';
import {useTitle} from 'vue-page-title';

const { t } = useI18n();

const { setTitle } = useTitle();
setTitle(t('notFound.title'));

definePage({
  meta: {
    requiresAuth: false,
    layout: 'unauthenticated',
  },
});
</script>

<template>
  <v-card
    class="ma-auto mt-9 pa-5"
    max-width="500"
    elevation="10"
  >
    <v-card-title>{{ t('notFound.title') }}</v-card-title>
    <v-card-actions>
      <v-btn
        prepend-icon="mdi-home"
        color="primary"
        text="Home"
        variant="elevated"
        @click="$router.push('/')"
      />
    </v-card-actions>
  </v-card>
</template>
